import React, { useState } from "react";
import { Modal, Form, Input, InputNumber, message, Row, Col, Button } from "antd";
import axios from "axios";

const AddFoodModal = ({ visible, onClose, onAdded, foodName="" }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/foods`, { ...values }, { withCredentials: true });
      message.success("Food item added successfully");
      form.resetFields();
      onAdded(response.data);
      onClose();
    } catch (error) {
      if (error.errorFields) {
        // validation errors handled by Ant Design Form
      } else {
        message.error("Failed to add food item: " + (error.message || error.toString()));
      }
    } finally {
      setLoading(false);
    }
  };

  // Autofill handler that calls backend with name field and fills form
  const handleAutofill = async () => {
    const name = form.getFieldValue("name");
    if (!name) {
      message.warning("Please enter a food name first.");
      return;
    }
    setFetching(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ai/new-food?name=${encodeURIComponent(name)}`, {
        withCredentials: true,
      });
      // Populate form with FoodDTO returned by backend
      form.setFieldsValue(response.data);
      message.success("Fields auto-filled.");
    } catch (error) {
      message.error("Failed to fetch food  " + (error.message || error.toString()));
    } finally {
      setFetching(false);
    }
  };

  return (
    <Modal
      title="Add Food Item"
      visible={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      confirmLoading={loading}
      okText="Add"
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ name: foodName, calories: 0, fat: 0, cholesterol: 0, sodium: 0 }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the food name" }]}
        >
          <Input placeholder="Food name" />
        </Form.Item>

        <Button
          type="default"
          style={{ marginBottom: 12 }}
          loading={fetching}
          onClick={handleAutofill}
        >
          Autofill Data with AI
        </Button>

        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} placeholder="Description (optional)" />
        </Form.Item>

        <Form.Item
          label="Calories"
          name="calories"
          rules={[
            { type: "number", min: 0, required: true, message: "Calories are required" },
          ]}
        >
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Calories" />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Fat (g)" name="fat" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Fat in grams" />
            </Form.Item>
            <Form.Item label="Cholesterol (mg)" name="cholesterol" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Cholesterol in mg" />
            </Form.Item>
            <Form.Item label="Sodium (mg)" name="sodium" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Sodium in mg" />
            </Form.Item>
            <Form.Item label="Carbohydrate (g)" name="carbohydrate" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Carbohydrate in grams" />
            </Form.Item>
            <Form.Item label="Protein (g)" name="protein" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Protein in grams" />
            </Form.Item>
            <Form.Item label="Vitamin A (IU)" name="vitaminA" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Vitamin A in IU" />
            </Form.Item>
            <Form.Item label="Vitamin C (mg)" name="vitaminC" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Vitamin C in mg" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Calcium (mg)" name="calcium" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Calcium in mg" />
            </Form.Item>
            <Form.Item label="Iron (mg)" name="iron" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Iron in mg" />
            </Form.Item>
            <Form.Item label="Fibre (g)" name="fibre" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Fibre in grams" />
            </Form.Item>
            <Form.Item label="Sugar (g)" name="sugar" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="Sugar in grams" />
            </Form.Item>
            <Form.Item label="ml per gcf" name="mlpergcf" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="ml per gcf" />
            </Form.Item>
            <Form.Item label="1 per gcf" name="onepergcf" rules={[{ type: "number", min: 0 }]}>
              <InputNumber style={{ width: "100%" }} min={0} placeholder="1 per gcf" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFoodModal;


